import VideoProgressBar from './VideoProgressBar'
export default VideoProgressBar